import axios from "axios";
import operators from "../../models/workflow/operators";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getOperators() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/operadores`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return operators.fromJson(item);
      });
    });
  }
}
export default service;
